import React from 'react';
import Button from '@material-ui/core/Button';
import {
	DialogActions,
	DialogContent,
	Dialog,
	DialogTitle,
	DialogContentText,
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { I18n } from 'react-redux-i18n';

export default function NoExportableErrors({ handleClose, open, errors }) {
	return (
		<Dialog id="noExportDialog" onClose={handleClose} open={open}>
			<DialogTitle> {I18n.t('exportVat.modal.title')}</DialogTitle>
			<DialogContent>
				<DialogContentText>
					<Alert severity="warning">
						{I18n.t('exportVat.modal.text_alert')}{' '}
						<a href={I18n.t('exportVat.url_slite_help')} target="blank">
							<b>
								<u>{I18n.t('exportVat.modal.text_alert_help')}</u>
							</b>{' '}
						</a>
					</Alert>
					{errors.payments && errors.payments.length ? (
						<p style={{ marginTop: 15, fontWeight: 'italic', fontSize: 13 }}>
							{I18n.t('exportVat.modal.payment_note')}
						</p>
					) : null}

					{errors.vat && errors.vat.length ? (
						<div className="noExportableErrorSection">
							<h2>{I18n.t('exportVat.modal.vat')}</h2>
							<ul>
								{errors.vat.map(e => (
									<li>{e}</li>
								))}
							</ul>
						</div>
					) : null}
					{errors.sales && errors.sales.length ? (
						<div className="noExportableErrorSection">
							<h2>{I18n.t('exportVat.modal.product')}</h2>
							<ul>
								{errors.sales.map(e => (
									<li>{e}</li>
								))}
							</ul>
						</div>
					) : null}
					{errors.payments && errors.payments.length ? (
						<div className="noExportableErrorSection">
							<h2>{I18n.t('exportVat.modal.payment')}</h2>
							<ul>
								{errors.payments.map(e => (
									<li>{e}</li>
								))}
							</ul>
						</div>
					) : null}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				{' '}
				<Button onClick={handleClose} color="primary" autoFocus>
					{I18n.t('exportVat.modal.close')}
				</Button>
			</DialogActions>
		</Dialog>
	);
}
